/**
 * When any API returns statuscode !== 200 and the response contains a url key,
 * automatically download that URL as a log file (KCRA pattern).
 * Used for delegate-team-user and other APIs that return a log URL on failure.
 */
import axios from "axios";
import { BACKEND_URL_2 } from "../actions/types";
import { appendCompanyToUrl } from "./downloadUrl";

function downloadLogFromResponse(response) {
  const data = response?.data ?? response;
  if (!data) return;
  const url = data.url ?? data.data?.url;
  if (!url || typeof url !== "string" || !url.trim()) return;
  const base = BACKEND_URL_2.replace(/\/$/, "");
  const fullUrl = url.startsWith("http") ? url : `${base}${url.startsWith("/") ? url : `/${url}`}`;
  /** Backend `download-file?download-token=…` URLs need `company` as a query param for tenant scoping. */
  const fullUrlWithCompany = appendCompanyToUrl(fullUrl);
  const token = localStorage.getItem("token");
  const req = new XMLHttpRequest();
  req.open("GET", fullUrlWithCompany, true);
  if (token) req.setRequestHeader("Authorization", token);
  req.responseType = "blob";
  req.onload = () => {
    try {
      const blob = req.response;
      if (!blob) return;
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = url.indexOf("instanceLog") !== -1 ? "instance-log.txt" : "errorlog.txt";
      link.click();
      window.URL.revokeObjectURL(link.href);
    } catch (e) {
      // ignore
    }
  };
  req.send();
}

axios.interceptors.response.use(
  (response) => {
    const data = response?.data;
    if (data && data.statuscode != null && data.statuscode !== 200) {
      const url = data.url ?? data.data?.url;
      if (url && typeof url === "string" && url.trim()) {
        downloadLogFromResponse(response);
      }
    }
    return response;
  },
  (error) => Promise.reject(error)
);
